import React from "react";
import Paragraph from "../Paragraph";

const Paragraphs = ({ data, className }) => {
  return data.map((para) => <Paragraph id={para.id} data={para} className={className} />);
};

export default Paragraphs;
